import { createSelector } from "reselect";

const selectFormularioAssociadoItemProcesso = (state) => state.formularioAssociadoItemProcesso;

export const makeSelectFormularioModeloByItemId = (idProcessoItem) => createSelector(
  [selectFormularioAssociadoItemProcesso],
  (formularioAssociadoItemProcesso) => formularioAssociadoItemProcesso[idProcessoItem] ?? null
);
